import {
    CREATE_COLLECTION_RECORD,
    CREATE_COLLECTION_RECORD_SUCCESS,
    CREATE_COLLECTION_RECORD_ERROR,
    UPDATE_COLLECTION_RECORD_STATE,
  } from "../actions";
  
  const INIT_STATE = {
    isCollectionNewRecordPanelShown: false,
    loading: false,
    collectionRecordCreateError: null,
    collectionRecordSaved: null
  };
  
  export default (state = INIT_STATE, action) => {
    switch (action.type) {
      case CREATE_COLLECTION_RECORD:
        return { ...state, loading: true, collectionItemCreateError: null, record: action.payload.newRecord };
      case CREATE_COLLECTION_RECORD_SUCCESS:
        return { ...state, loading: false, collectionItemCreateError: null, collectionItemSaved: action.payload, isNewRecordPanelShown: false };
      case CREATE_COLLECTION_RECORD_ERROR:
        return { ...state, loading: false, collectionItemCreateError: action.payload.message };
      case UPDATE_COLLECTION_RECORD_STATE:
        return { ...state, ...action.payload.updatedValues }
      default:
        return { ...state };
    }
  };
  